<template>
  <div :class="$style.container">
    <div v-if="security" :class="$style.security">
      <pci-dss />
      <verified-by-visa />
      <mir-accept />
      <mc-secure-code />
    </div>
    <div :class="$style.footer">
      <div :class="$style.copyright">
        <p v-if="getCopyright">
          &copy; {{ $t(getCopyright) }}
        </p>
        <p v-text="$t(getCompanyName)" />
      </div>
      <div :class="$style.logo">
        <img :src="getLogoLink" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PciDss from 'atoms/security/PciDss';
import VerifiedByVisa from 'atoms/security/VerifiedByVisa';
import MirAccept from 'atoms/security/MirAccept';
import McSecureCode from 'atoms/security/McSecureCode';

export default {
  name: 'BaseFooter',
  components: {
    PciDss,
    VerifiedByVisa,
    MirAccept,
    McSecureCode,
  },
  props: {
    security: Boolean,
  },
  computed: {
    ...mapGetters([
      'isPrimaryUzbekistanProvider',
      'isPrimaryRussianProvider',
      'getCompanyName',
      'getCopyright',
      'getLogoLink',
    ]),
  },
};
</script>

<style lang="sass" module>
  .container
    +size(100%, auto)
    overflow: hidden

  .footer
    +flexbox
    +align-items(center)

  .security
    +flexbox
    +align-items(center)
    +justify-content(space-around)
    margin-bottom: 20px

  .copyright
    +footer-text
    +font-type(regular, 11, 16)
    color: rgba(33, 33, 33, 0.5)

  .logo
    +flexbox
    +size(96px, 66px)
    margin-left: auto

    img
      width: 100%
</style>
